/**
 * Collection grid: keep Shopify sort (best selling, etc.), then place sold-out
 * products after all available ones across the whole collection. Pagination
 * slices that sorted list in the browser so page 1 is never filled with
 * sold-out items while in-stock products sit on page 2.
 */
(function () {
  var PAGE_PARAM = 'lm_page';
  var bound = false;
  var infiniteObserver = null;

  function getGrid(scope) {
    var root = scope || document;
    return root.querySelector ? root.querySelector('#product-grid[data-lm-stock-sort]') : null;
  }

  function getPagination(scope) {
    var root = scope || document;
    return root.querySelector ? root.querySelector('[data-lm-collection-pagination]') : null;
  }

  function paginationType(grid) {
    return (grid && grid.getAttribute('data-lm-pagination-type')) || 'paginated';
  }

  function currentPageFromUrl() {
    try {
      var page = parseInt(new URL(window.location.href).searchParams.get(PAGE_PARAM) || '1', 10);
      return page > 0 ? page : 1;
    } catch (err) {
      return 1;
    }
  }

  function setUrlPage(page, type) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (type !== 'paginated' || page <= 1) {
        url.searchParams.delete(PAGE_PARAM);
      } else {
        url.searchParams.set(PAGE_PARAM, String(page));
      }
      if (window.history && window.history.pushState) {
        window.history.pushState({ lmCollectionPage: page }, '', url.pathname + url.search + url.hash);
      }
    } catch (err) {}
  }

  function applyPage(grid, page, type) {
    var perPage = parseInt(grid.getAttribute('data-lm-per-page'), 10) || 24;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.lm-collection-item')).filter(function (el) {
      return !el.classList.contains('lm-filter-out');
    });
    var promotions = Array.prototype.slice.call(grid.querySelectorAll('.promotion-column[data-lm-slot]'));
    var total = items.length;
    var totalPages = Math.max(1, Math.ceil(total / perPage));
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;

    if (type === 'paginated') {
      var start = (page - 1) * perPage;
      var end = start + perPage;
      items.forEach(function (el, index) {
        el.classList.toggle('is-hidden', index < start || index >= end);
      });
      promotions.forEach(function (el) {
        var slot = parseInt(el.getAttribute('data-lm-slot'), 10);
        el.classList.toggle('is-hidden', slot < start + 1 || slot > end);
      });
    } else {
      var visible = page * perPage;
      items.forEach(function (el, index) {
        el.classList.toggle('is-hidden', index >= visible);
      });
      promotions.forEach(function (el) {
        var slot = parseInt(el.getAttribute('data-lm-slot'), 10);
        el.classList.toggle('is-hidden', slot > visible);
      });
    }

    document.documentElement.classList.remove('lm-collection-await-page');
    return { page: page, perPage: perPage, total: total, totalPages: totalPages };
  }

  function updatePaginatedUi(pagination, state) {
    if (!pagination) return;
    pagination.hidden = state.totalPages <= 1;
    pagination.classList.toggle('lm-pagination-hidden', state.totalPages <= 1);
    pagination.querySelectorAll('.page').forEach(function (el) {
      var link = el.querySelector('a[data-lm-page]');
      var number = link ? parseInt(link.getAttribute('data-lm-page'), 10) : 0;
      var isCurrent = number === state.page;
      el.hidden = number > state.totalPages;
      el.classList.toggle('current', isCurrent);
      if (isCurrent) el.setAttribute('aria-current', 'page');
      else el.removeAttribute('aria-current');
    });
    var prev = pagination.querySelector('[data-lm-page="prev"]');
    var next = pagination.querySelector('[data-lm-page="next"]');
    if (prev) {
      if (state.page <= 1) prev.setAttribute('disabled', '');
      else prev.removeAttribute('disabled');
    }
    if (next) {
      if (state.page >= state.totalPages) next.setAttribute('disabled', '');
      else next.removeAttribute('disabled');
    }
  }

  function updateLoadMoreUi(pagination, state) {
    if (!pagination) return;
    var moreLeft = state.page < state.totalPages;
    pagination.classList.toggle('is-complete', !moreLeft);
    var button = pagination.querySelector('[data-lm-page="more"]');
    if (button) button.hidden = !moreLeft;
    if (!moreLeft && infiniteObserver) {
      infiniteObserver.disconnect();
      infiniteObserver = null;
    }
  }

  function scrollToGrid(grid) {
    if (!grid || !grid.getBoundingClientRect) return;
    var top = grid.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function goTo(page, options) {
    var grid = getGrid();
    if (!grid) return;
    var type = paginationType(grid);
    var pagination = getPagination();
    var state = applyPage(grid, page, type);
    if (pagination) pagination.lmPage = state.page;
    if (type === 'paginated') {
      if (!options || options.updateUrl !== false) setUrlPage(state.page, type);
      updatePaginatedUi(pagination, state);
      if (!options || options.scroll !== false) scrollToGrid(grid);
    } else {
      updateLoadMoreUi(pagination, state);
    }
    window.DtcEsTracking?.scan();
    return state;
  }

  function observeInfinite(pagination, grid) {
    if (infiniteObserver) {
      infiniteObserver.disconnect();
      infiniteObserver = null;
    }
    if (!pagination || paginationType(grid) !== 'infinite' || typeof IntersectionObserver !== 'function') return;
    infiniteObserver = new IntersectionObserver(
      function (entries) {
        if (!entries[0] || entries[0].intersectionRatio < 1) return;
        var current = pagination.lmPage || 1;
        var perPage = parseInt(grid.getAttribute('data-lm-per-page'), 10) || 24;
        var totalPages = Math.max(1, Math.ceil(grid.querySelectorAll('.lm-collection-item:not(.lm-filter-out)').length / perPage));
        if (current >= totalPages) return;
        goTo(current + 1, { scroll: false, updateUrl: false });
      },
      { threshold: [1] }
    );
    infiniteObserver.observe(pagination);
  }

  function init() {
    var grid = getGrid();
    if (!grid) {
      document.documentElement.classList.remove('lm-collection-await-page');
      return;
    }
    var type = paginationType(grid);
    var startPage = type === 'paginated' ? currentPageFromUrl() : 1;
    var state = goTo(startPage, { scroll: false, updateUrl: false });
    var pagination = getPagination();
    if (pagination && state) pagination.lmPage = state.page;
    observeInfinite(pagination, grid);
  }

  function onClick(event) {
    var link = event.target.closest && event.target.closest('[data-lm-collection-pagination] [data-lm-page]');
    if (!link || link.hasAttribute('disabled')) return;
    event.preventDefault();
    var grid = getGrid();
    var pagination = getPagination();
    if (!grid || !pagination) return;
    var type = paginationType(grid);
    var action = link.getAttribute('data-lm-page');
    var page = pagination.lmPage || 1;
    if (action === 'prev') page -= 1;
    else if (action === 'next' || action === 'more') page += 1;
    else page = parseInt(action, 10) || 1;
    goTo(page, { scroll: type === 'paginated', updateUrl: type === 'paginated' });
  }

  if (!bound) {
    bound = true;
    document.addEventListener('click', onClick);
    document.addEventListener('facets:updated', init);
    window.addEventListener('popstate', init);
  }

  window.lmInitCollectionGrid = init;
  init();
})();
